const bengali = {
  name: "Bengali",
  native_name: "বাংলা",
  code: "bn",
};

const bn = {
  translation: {
    report_bug: "বাগ রিপোর্ট করুন",
    import: "ইম্পোর্ট করুন",
    file: "ফাইল",
    new: "নতুন",
    new_window: "নতুন উইন্ডো",
    open: "ওপেন করুন",
    save: "সেভ করুন",
    save_as: "নতুন নামে সেভ করুন",
    save_as_template: "টেমপ্লেট হিসাবে সেভ করুন",
    template_saved: "টেমপ্লেট সেভ হয়েছে!",
    rename: "নাম পরিবর্তন করুন",
    delete_diagram: "ডায়াগ্রাম ডিলিট করুন",
    are_you_sure_delete_diagram:
      "আপনি কি এই ডায়াগ্রামটি মুছে ফেলতে চান? এই অপারেশনটি অপরিবর্তনীয়।",
    oops_smth_went_wrong: "ওহো! কিছু ভুল হয়েছে।",
    import_diagram: "ডায়াগ্রাম ইম্পোর্ট করুন",
    import_from_source: "SQL থেকে ইম্পোর্ট করুন",
    export_as: "রপ্তানি হিসাবে",
    export_source: "SQL রপ্তানি করুন",
    models: "মডেল",
    exit: "বেরিয়ে যান",
    edit: "এডিট করুন",
    undo: "পূর্বাবস্থা ফিরিয়ে নিন",
    redo: "পুনরায় করুন",
    clear: "মুছে ফেলুন",
    are_you_sure_clear:
      "আপনি কি ডায়াগ্রামটি মুছে ফেলতে চান? এটি অপরিবর্তনীয়।",
    cut: "কাট করুন",
    copy: "কপি করুন",
    paste: "পেস্ট করুন",
    duplicate: "প্রতিলিপি করুন",
    delete: "মুছে ফেলুন",
    copy_as_image: "ছবি হিসাবে কপি করুন",
    view: "ভিউ",
    header: "মেনুবার",
    sidebar: "সাইডবার",
    issues: "সমস্যা",
    presentation_mode: "প্রেজেন্টেশন মোড",
    strict_mode: "স্ট্রিক্ট মোড",
    field_details: "ক্ষেত্রের বিস্তারিত",
    reset_view: "ভিউ রিসেট করুন",
    show_grid: "গ্রিড দেখান",
    show_cardinality: "কার্ডিনালিটি দেখান",
    theme: "থিম",
    light: "লাইট",
    dark: "ডার্ক",
    zoom_in: "জুম ইন করুন",
    zoom_out: "জুম আউট করুন",
    fullscreen: "ফুলস্ক্রিন",
    settings: "সেটিংস",
    show_timeline: "টাইমলাইন দেখান",
    autosave: "অটোসেভ",
    panning: "প্যানিং",
    show_debug_coordinates: "ডিবাগ কোঅর্ডিনেট দেখান",
    transform: "ট্রান্সফর্ম",
    viewbox: "ভিউ বক্স",
    cursor_coordinates: "কার্সার কোঅর্ডিনেট",
    coordinate_space: "স্থান",
    coordinate_space_screen: "স্ক্রিন",
    coordinate_space_diagram: "ডায়াগ্রাম",
    table_width: "টেবিলের প্রস্থ",
    language: "ভাষা",
    flush_storage: "স্টোরেজ ফ্লাশ করুন",
    are_you_sure_flush_storage:
      "আপনি কি স্টোরেজ ফ্লাশ করতে চান? এটি আপনার সমস্ত ডায়াগ্রাম এবং কাস্টম টেমপ্লেটগুলি মুছে ফেলবে।",
    storage_flushed: "স্টোরেজ ফ্লাশ হয়েছে",
    help: "সাহায্য",
    shortcuts: "শর্টকাট",
    ask_on_discord: "ডিসকর্ডে আমাদের জিজ্ঞাসা করুন",
    feedback: "প্রতিক্রিয়া",
    no_changes: "কোনও পরিবর্তন নেই",
    loading: "লোড হচ্ছে...",
    last_saved: "শেষ সেভ",
    saving: "সেভ হচ্ছে...",
    failed_to_save: "সেভ ব্যর্থ হয়েছে",
    fit_window_reset: "উইন্ডোতে ফিট করুন / রিসেট করুন",
    zoom: "জুম",
    add_table: "টেবিল যোগ করুন",
    add_area: "এরিয়া যোগ করুন",
    add_note: "নোট যোগ করুন",
    add_type: "টাইপ যোগ করুন",
    to_do: "টু-ডু",
    tables: "টেবিল",
    relationships: "সম্পর্কগুলি",
    subject_areas: "বিষয় এলাকা",
    notes: "নোট",
    types: "প্রকার",
    search: "অনুসন্ধান করুন...",
    no_tables: "কোনও টেবিল নেই",
    no_tables_text: "আপনার ডায়াগ্রামটি তৈরি করা শুরু করুন!",
    no_relationships: "কোনও সম্পর্ক নেই",
    no_relationships_text:
      "ক্ষেত্রগুলিকে সংযুক্ত করতে এবং সম্পর্ক গঠনের জন্য টানুন!",
    no_subject_areas: "কোনও বিষয় এলাকা নেই",
    no_subject_areas_text: "টেবিলগুলি গোষ্ঠীবদ্ধ করতে বিষয় এলাকা যোগ করুন!",
    no_notes: "কোনও নোট নেই",
    no_notes_text: "অতিরিক্ত তথ্য রেকর্ড করার জন্য নোট ব্যবহার করুন",
    no_types: "কোনও প্রকার নেই",
    no_types_text: "আপনার নিজস্ব কাস্টম ডেটা টাইপগুলি তৈরি করুন",
    no_issues: "কোনও সমস্যা সনাক্ত করা হয়নি।",
    strict_mode_is_on_no_issues:
      "স্ট্রিক্ট মোড বন্ধ রয়েছে, তাই কোনও সমস্যা প্রদর্শিত হবে না।",
    name: "নাম",
    type: "প্রকার",
    null: "নাল",
    not_null: "নাল নয়",
    primary: "প্রাথমিক",
    unique: "অনন্য",
    autoincrement: "স্বয়ংক্রিয় বৃদ্ধি",
    default_value: "ডিফল্ট মান",
    check: "চেক এক্সপ্রেশন",
    this_will_appear_as_is:
      "*এটি তৈরি করা স্ক্রিপ্টে অপরিবর্তিত অবস্থায় প্রদর্শিত হবে।",
    comment: "মন্তব্য",
    add_field: "ক্ষেত্র যোগ করুন",
    values: "মান",
    size: "আকার",
    precision: "প্রেসিশন",
    set_precision: "প্রেসিশন সেট করুন: 'আকার, সংখ্যা'",
    use_for_batch_input: "ব্যাচ ইনপুটের জন্য ব্যবহার করুন",
    indices: "ইনডিসেস",
    add_index: "ইনডেক্স যোগ করুন",
    select_fields: "ক্ষেত্রগুলি নির্বাচন করুন",
    title: "শিরোনাম",
    not_set: "সেট করা হয়নি",
    foreign: "বৈদেশিক",
    cardinality: "কার্ডিনালিটি",
    on_update: "আপডেটের সময়",
    on_delete: "ডিলিটের সময়",
    swap: "সোয়াপ",
    one_to_one: "এক থেকে এক",
    one_to_many: "এক থেকে অনেক",
    many_to_one: "অনেক থেকে এক",
    content: "বিষয়বস্তু",
    types_info:
      "এই বৈশিষ্ট্যটি PostgreSQL-এর মত অবজেক্ট-রিলেশনাল DBMS-এর জন্য।\nযদি MySQL বা MariaDB এর জন্য ব্যবহার করা হয় তবে একটি JSON টাইপ তৈরি হবে সংশ্লিষ্ট json বৈধতা যাচাই সহ।\nযদি SQLite এর জন্য ব্যবহার করা হয় তবে এটি একটি BLOB এ অনুবাদ হবে।\nযদি MSSQL এর জন্য ব্যবহার করা হয় তবে প্রথম ক্ষেত্রের একটি টাইপ এলিয়াস তৈরি হবে।",
    table_deleted: "টেবিল মুছে ফেলা হয়েছে",
    area_deleted: "এরিয়া মুছে ফেলা হয়েছে",
    note_deleted: "নোট মুছে ফেলা হয়েছে",
    relationship_deleted: "সম্পর্ক মুছে ফেলা হয়েছে",
    type_deleted: "টাইপ মুছে ফেলা হয়েছে",
    cannot_connect: "সংযোগ করা যাচ্ছে না, কলামগুলির বিভিন্ন প্রকার আছে",
    copied_to_clipboard: "ক্লিপবোর্ডে কপি করা হয়েছে",
    create_new_diagram: "নতুন ডায়াগ্রাম তৈরি করুন",
    cancel: "বাতিল করুন",
    open_diagram: "ডায়াগ্রাম ওপেন করুন",
    rename_diagram: "ডায়াগ্রামের নাম পরিবর্তন করুন",
    export: "রপ্তানি করুন",
    export_image: "ছবি রপ্তানি করুন",
    create: "তৈরি করুন",
    confirm: "নিশ্চিত করুন",
    last_modified: "শেষ সংশোধন",
    drag_and_drop_files:
      "ফাইলটি এখানে ড্র্যাগ এবং ড্রপ করুন বা আপলোড করতে ক্লিক করুন।",
    support_json_and_ddb: "JSON এবং DDB ফাইলগুলি সমর্থিত",
    upload_sql_to_generate_diagrams:
      "আপনার টেবিল এবং কলামগুলি স্বয়ংক্রিয়ভাবে তৈরি করতে একটি SQL ফাইল আপলোড করুন।",
    overwrite_existing_diagram: "বিদ্যমান ডায়াগ্রামটি ওভাররাইট করুন",
    only_mysql_supported:
      "*এখন পর্যন্ত শুধুমাত্র MySQL স্ক্রিপ্ট লোডিং সমর্থিত।",
    blank: "খালি",
    filename: "ফাইলের নাম",
    table_w_no_name: "নাম ছাড়াই একটি টেবিল ঘোষণা করা হয়েছে",
    duplicate_table_by_name: "'{{tableName}}' নামকরণ করা টেবিলের অনুলিপি",
    empty_field_name: "'{{tableName}}' টেবিলে ফাঁকা ক্ষেত্রের `name`",
    empty_field_type: "'{{tableName}}' টেবিলে ফাঁকা ক্ষেত্রের `type`",
    no_values_for_field:
      "'{{tableName}}' টেবিলের '{{fieldName}}' ক্ষেত্রটি `{{type}}` প্রকারের, তবে কোনও মান নির্দিষ্ট করা হয়নি",
    default_doesnt_match_type:
      "'{{tableName}}' টেবিলের '{{fieldName}}' ক্ষেত্রটির জন্য ডিফল্ট মান তার প্রকারের সাথে মেলে না",
    not_null_is_null:
      "'{{tableName}}' টেবিলের '{{fieldName}}' ক্ষেত্রটি NOT NULL তবে ডিফল্ট NULL",
    duplicate_fields:
      "'{{tableName}}' টেবিলের '{{fieldName}}' নামে ডুপ্লিকেট ক্ষেত্র",
    duplicate_index:
      "'{{tableName}}' টেবিলের '{{indexName}}' নামে ডুপ্লিকেট ইনডেক্স",
    empty_index: "'{{tableName}}' টেবিলের ইনডেক্স কোনও কলামকে ইনডেক্স করে না",
    no_primary_key: "'{{tableName}}' টেবিলের কোনও প্রাথমিক কী নেই",
    type_with_no_name: "নাম ছাড়াই একটি টাইপ ঘোষণা করা হয়েছে",
    duplicate_types: "'{{typeName}}' নামকরণের সাথে ডুপ্লিকেট টাইপ",
    type_w_no_fields: "ক্ষেত্র ছাড়াই '{{typeName}}' টাইপ ঘোষণা করা হয়েছে",
    empty_type_field_name: "'{{typeName}}' টাইপের ফাঁকা ক্ষেত্রের `name`",
    empty_type_field_type: "'{{typeName}}' টাইপের ফাঁকা ক্ষেত্রের `type`",
    no_values_for_type_field:
      "'{{typeName}}' টাইপের '{{fieldName}}' ক্ষেত্রটি `{{type}}` প্রকারের, তবে কোনও মান নির্দিষ্ট করা হয়নি",
    duplicate_type_fields:
      "'{{typeName}}' টাইপের '{{fieldName}}' নামে ডুপ্লিকেট ক্ষেত্র",
    duplicate_reference: "'{{refName}}' নামে ডুপ্লিকেট রেফারেন্স",
    circular_dependency: "'{{refName}}' টেবিল জড়িত একটি চক্রাকার নির্ভরতা",
    timeline: "টাইমলাইন",
    priority: "অগ্রাধিকার",
    none: "কোনও নয়",
    low: "কম",
    medium: "মাঝারি",
    high: "উচ্চ",
    sort_by: "ক্রমানুসারে সাজান",
    my_order: "আমার আদেশ",
    completed: "সম্পন্ন",
    alphabetically: "বর্ণানুক্রমিকভাবে",
    add_task: "কাজ যোগ করুন",
    details: "বিস্তারিত",
    no_tasks: "আপনার এখনও কোনও কাজ নেই।",
    no_activity: "আপনার এখনও কোনও কার্যকলাপ নেই।",
    move_element: "{{name}} কে {{coords}} তে সরান",
    edit_area: "{{extra}} এরিয়া {{areaName}} সম্পাদনা করুন",
    delete_area: "এরিয়া {{areaName}} মুছুন",
    edit_note: "{{extra}} নোট {{noteTitle}} সম্পাদনা করুন",
    delete_note: "নোট {{noteTitle}} মুছুন",
    edit_table: "{{extra}} টেবিল {{tableName}} সম্পাদনা করুন",
    delete_table: "টেবিল {{tableName}} মুছুন",
    edit_type: "{{extra}} টাইপ {{typeName}} সম্পাদনা করুন",
    delete_type: "টাইপ {{typeName}} মুছুন",
    add_relationship: "সম্পর্ক যোগ করুন",
    edit_relationship: "{{extra}} সম্পর্ক {{refName}} সম্পাদনা করুন",
    delete_relationship: "সম্পর্ক {{refName}} মুছুন",
    not_found: "খুঁজে পাওয়া যায়নি",
    pick_db: "একটি ডাটাবেস নির্বাচন করুন",
    generic: "জেনেরিক",
    generic_description:
      "জেনেরিক ডায়াগ্রামগুলি যে কোনও SQL ফ্লেভারে রপ্তানি করা যেতে পারে তবে কয়েকটি ডেটা টাইপ সমর্থন করে।",
    enums: "এনামস",
    add_enum: "এনাম যোগ করুন",
    edit_enum: "{{extra}} এনাম {{enumName}} সম্পাদনা করুন",
    delete_enum: "এনাম মুছুন",
    enum_w_no_name: "নাম ছাড়াই একটি এনাম পাওয়া গেছে",
    enum_w_no_values: "কোনও মান ছাড়াই এনাম '{{enumName}}' পাওয়া গেছে",
    duplicate_enums: "'{{enumName}}' নামে ডুপ্লিকেট এনামস",
    no_enums: "কোনও এনাম নেই",
    no_enums_text: "এখানে এনামগুলি সংজ্ঞায়িত করুন",
    declare_array: "অ্যারে ঘোষণা করুন",
    empty_index_name:
      "'{{tableName}}' টেবিলে নাম ছাড়াই একটি ইনডেক্স ঘোষণা করা হয়েছে",
    didnt_find_diagram: "ওহো! ডায়াগ্রামটি পাওয়া যায়নি।",
    unsigned: "আনসাইন্ড",
  },
};

export { bn, bengali };
